import React from 'react';
import {Container, Grid, Header, Image} from 'semantic-ui-react';

export default function SplashCards() {

    return (
        <Container className='hooli-splash-margin'>
            <Grid stackable centered columns={3}>
                <Grid.Column>
                    <Image src='/img/budgets.svg' className='hooli-image' />
                    <Header as='h2' icon>
                        Budgets? You betcha
                        <Header.Subheader className='hooli-card-content'>Easily create budgets, and see our suggestions based on your spending.</Header.Subheader>
                    </Header>
                </Grid.Column>
                <Grid.Column>
                    <Image src='/img/bills.svg' className='hooli-image' />
                    <Header as='h2' icon>
                        Bills? Done
                        <Header.Subheader className='hooli-card-content'>Track your bills like never before. Get alerts when it's time to pay so you never miss one.</Header.Subheader>
                    </Header>
                </Grid.Column>
                <Grid.Column>
                    <Image src='/img/credit.svg' className='hooli-image' />
                    <Header as='h2' icon>
                        Credit score? Checked
                        <Header.Subheader className='hooli-card-content'>Find out yours for free and get tips to help improve it, no credit card required.</Header.Subheader>
                    </Header>
                </Grid.Column>
            </Grid>
        </Container>
    )

}
